import { DetalleBoletaHonorarios } from "./DetalleBoletaHonorarios";

//
export class ResumenDetallesBhe {
   detalles: DetalleBoletaHonorarios[];
   bruto: number;
   montoRetencion: number;
   liquido: number;
   retenido: number;
   pagado: number;
   total: number;
}
